module.exports = "/_next/static/images/T1-cc131423387f85e6bc3683e417b53e3b.png";